import { useEffect, useState } from 'react';
import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import {
  FilterTabButtonBasicComponent,
  FilterTabButtonBasicOnSelectProps,
} from './filter-tab-button-basic.component';

export const FilterTabButtonStandAloneComponent = ({
  filter,
  filterSelection,
  onSelect,
}: FilterTabButtonBasicOnSelectProps) => {
  const [selectedValue, setSelectedValue] = useState<
    FilterSelectedValue | undefined
  >();

  useEffect(() => {
    if (filterSelection) {
      const selVal = filterSelection.find((i) => i.id === filter.id);
      if (selVal) {
        setSelectedValue((prevVal) => prevVal ?? selVal);
      } else {
        setSelectedValue(
          (prevVal) =>
            prevVal ?? {
              id: filter.id,
              values: [],
              matchStrategy: filter.defaultSelectedValue?.matchStrategy,
            },
        );
      }
    }
  }, [filter.id, filter.defaultSelectedValue, filterSelection]);
  return (
    <FilterTabButtonBasicComponent
      filter={filter}
      filterSelection={filterSelection}
      selectedValue={selectedValue}
      setSelectedValue={setSelectedValue}
      onSelect={onSelect}
    />
  );
};
